/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzAllowPermissionToGroupManagedPermissionsMutationResponse, UsersAuthzAllowPermissionToGroupManagedPermissionsPathParams, UsersAuthzAllowPermissionToGroupManagedPermissions401, UsersAuthzAllowPermissionToGroupManagedPermissions403 } from "../models/UsersAuthzAllowPermissionToGroupManagedPermissions";

export function getUsersAuthzAllowPermissionToGroupManagedPermissionsUrl(groupId: UsersAuthzAllowPermissionToGroupManagedPermissionsPathParams["groupId"], permission: UsersAuthzAllowPermissionToGroupManagedPermissionsPathParams["permission"]) {
  const res = { method: 'POST', url: `/users-authz/v1/groups/${groupId}/permissions/${permission}/allow` as const }
  return res
}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Allow a permission for a group
 * {@link /users-authz/v1/groups/:groupId/permissions/:permission/allow}
 */
export async function usersAuthzAllowPermissionToGroupManagedPermissions(groupId: UsersAuthzAllowPermissionToGroupManagedPermissionsPathParams["groupId"], permission: UsersAuthzAllowPermissionToGroupManagedPermissionsPathParams["permission"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzAllowPermissionToGroupManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzAllowPermissionToGroupManagedPermissions401 | UsersAuthzAllowPermissionToGroupManagedPermissions403>, unknown>({ method : "POST", url : getUsersAuthzAllowPermissionToGroupManagedPermissionsUrl(groupId, permission).url.toString(), ... requestConfig })
  return res.data
}